import each from 'lodash/each'
import debounce from 'lodash/debounce'

import LiveStyleSheet from './live-style-sheet'
import StringStyleSheet from './string-style-sheet'

let currentZoom = null
let tempSwapStyleSheets
let stylesheets = {}
let lastWindowWidth = 0
let storeZoom = null

// let test = 0

function updateInternal (zoom, includeTemp) {
  currentZoom = zoom

  each(stylesheets, sheet => {
    sheet.updateMediaQueriesWidths(zoom)
  })
  if (includeTemp) {
    each(tempSwapStyleSheets, sheet => {
      sheet.updateMediaQueriesWidths(zoom)
    })
  }

  // some window code to commiunicate with navigation feature
  window._zoomFactor = zoom.zoomFactor
  if (window._zoomUpdateEvents) {
    window._zoomUpdateEvents.forEach(func => func())
  }

  // test += applyWidth
  // console.log('test', test)
}

const updateMediaQueriesWidthsDebounce = debounce(updateInternal, 200)

class StyleLoader {
  static setCollectStyleSheetsForPublish (value) {
    // keep references of old stylesheets for publishing from the editor
    if (value) {
      tempSwapStyleSheets = stylesheets
      stylesheets = {}
    } else {
      stylesheets = tempSwapStyleSheets
      tempSwapStyleSheets = null
    }
    StyleLoader.collectStyleSheetsForPublish = value
  }

  static getAllStyleSheetsForPublish () {
    let result = ''
    const imports = []
    each(stylesheets, sheet => {
      result += sheet.getCss() + '\n'
    })
    each(stylesheets, sheet => {
      sheet.getImports().forEach(imp => {
        if (!imports.includes(imp)) {
          imports.push(imp)
        }
      })
    })
    return imports.join('\n') + result
  }

  static clearAllStyleSheetsForPublish () {
    tempSwapStyleSheets = stylesheets
    stylesheets = {}
  }

  static updateMediaQueriesWidths (currentWindowWidth, editorWidth, zoomFactor) {
    lastWindowWidth = currentWindowWidth
    const deltaWidth = currentWindowWidth - editorWidth
    updateMediaQueriesWidthsDebounce({ deltaWidth, zoomFactor })
  }

  static tempOverrideZoomFactor (editorWidth, zoomFactor) {
    updateMediaQueriesWidthsDebounce.flush() // invoke old stalled function
    storeZoom = currentZoom || { zoomFactor: 1, deltaWidth: 0 }

    const currentWindowWidth = (lastWindowWidth === 0 ? window.innerWidth : lastWindowWidth)
    const deltaWidth = currentWindowWidth - editorWidth

    updateInternal({ deltaWidth, zoomFactor }, true)
  }

  static resetOverrideMediaQueriesScaling () {
    if (storeZoom) {
      updateInternal(storeZoom)
    }
    storeZoom = null
  }

  static setCss (stylesheetKey, css, isBaseStyling, layout, colorModel, stylesheetCollector) {
    stylesheetCollector = stylesheetCollector || stylesheets
    const Class = StyleLoader.collectStyleSheetsForPublish ? StringStyleSheet : LiveStyleSheet
    stylesheetCollector[stylesheetKey] = new Class(stylesheetKey, css, isBaseStyling, layout, colorModel, currentZoom)
  }

  static removeCss (stylesheetKey) {
    if (stylesheets[stylesheetKey]) {
      stylesheets[stylesheetKey].dispose()
      delete stylesheets[stylesheetKey]
    }
  }

  static loadOrUpdateLayout (layout, colorModel) {
    const stylesheetKey = layout.id
    const stylesheetCollector = stylesheets[stylesheetKey] ? stylesheets : colorModel.stylesheetCollector || stylesheets

    if (!stylesheetCollector[stylesheetKey]) {
      StyleLoader.setCss(stylesheetKey, layout.css, layout.id === 'base', layout, colorModel, stylesheetCollector)
    } else {
      stylesheetCollector[stylesheetKey].parseColors(colorModel)
    }
  }
}

const getCssClass = layout => {
  return layout.id
}

export default StyleLoader

export { getCssClass }
